import { render, staticRenderFns } from "./IndividualItems.vue?vue&type=template&id=bb309db8&"
import script from "./IndividualItems.vue?vue&type=script&lang=ts&"
export * from "./IndividualItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports